import React from "react"
import { View, Text, StyleSheet } from "react-native"
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard"

interface Props {
  summary: any
}

export default function IssueSummarySection({ summary }: Props) {
  if (!summary) return null

  const diagnostic = summary?.diagnostic
  const problem = diagnostic?.problem_analysis
  const cost = diagnostic?.cost_estimate
  const trades = diagnostic?.recommended_trades || []

  return (
    <View style={styles.wrapper}>
      
      {/* HEADER */}
      <View style={styles.headerRow}>
        <Text style={styles.mainTitle}>AI Analysis</Text>
        <View style={styles.badge}>
          <Text style={styles.badgeText}>
            {summary.analysis_type?.replaceAll("_", " ")}
          </Text>
        </View>
      </View>

      {/* PROBLEM CARD */}
      <View style={styles.card}>
        <Text style={styles.issueTitle}>
          {problem?.identified_issue}
        </Text>

        <View style={styles.urgencyBadge}>
          <Text style={styles.urgencyText}>
            Urgency: {problem?.urgency_level}
          </Text>
        </View>

        <Text style={styles.sectionHeading}>Potential Causes:</Text>
        {problem?.potential_causes?.map((cause: string, index: number) => (
          <Text key={index} style={styles.bulletText}>
            • {cause}
          </Text>
        ))}

        <Text style={styles.sectionHeading}>Mitigation:</Text>
        <Text style={styles.paragraph}>
          {problem?.mitigation_tasks}
        </Text>
      </View>

      {/* RECOMMENDED WORK */}
      <View style={styles.card}>
        <Text style={styles.sectionHeading}>Recommended Work</Text>
        <Text style={styles.paragraph}>
          {diagnostic?.recommended_work}
        </Text>
      </View>

      {/* COST ESTIMATE */}
      <View style={styles.card}>
        <Text style={styles.sectionHeading}>Estimated Cost</Text>

        <Text style={styles.costText}>
          {cost?.min_cost} - {cost?.max_cost} {cost?.currency}
        </Text>

        <Text style={styles.paragraph}>
          {cost?.notes}
        </Text>
      </View>

      {/* TRADES */}
      {trades.length > 0 && (
        <View style={styles.card}>
          <Text style={styles.sectionHeading}>Recommended Trades</Text>

          {trades.map((trade: any, index: number) => (
            <View key={index} style={styles.tradeChip}>
              <Text style={styles.tradeText}>
                {trade.trade_type}
              </Text>
            </View>
          ))}
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
    wrapper: {
      marginTop: 30
    },
  
    headerRow: {
      flexDirection: "row",
      alignItems: "center",
      gap: 12,
      marginBottom: 20
    },
  
    mainTitle: {
      fontSize: 22,
      fontWeight: "700",
      color: "#2D2D2D"
    },
  
    badge: {
      backgroundColor: "#F2B544",
      paddingHorizontal: 14,
      paddingVertical: 6,
      borderRadius: 20
    },
  
    badgeText: {
      fontSize: 12,
      fontWeight: "600",
      color: "#fff"
    },
  
    card: {
      backgroundColor: "#F9FAFB",
      padding: 20,
      borderRadius: 14,
      marginBottom: 18,
      borderWidth: 1,
      borderColor: "#E5E7EB"
    },
  
    issueTitle: {
      fontSize: 18,
      fontWeight: "700",
      marginBottom: 10
    },
  
    urgencyBadge: {
      alignSelf: "flex-start",
      backgroundColor: "#FFE5C2",
      paddingHorizontal: 12,
      paddingVertical: 5,
      borderRadius: 20,
      marginBottom: 15
    },
  
    urgencyText: {
      fontSize: 12,
      fontWeight: "600",
      color: "#B7791F"
    },
  
    sectionHeading: {
      fontSize: 16,
      fontWeight: "600",
      marginTop: 10,
      marginBottom: 8
    },
  
    bulletText: {
      fontSize: 14,
      color: "#555",
      marginBottom: 6
    },
  
    paragraph: {
      fontSize: 14,
      color: "#555",
      lineHeight: 22
    },
  
    costText: {
      fontSize: 22,
      fontWeight: "700",
      color: COLORS.primary,
      marginVertical: 8
    },
  
    tradeChip: {
      backgroundColor: "#E5E7EB",
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 20,
      alignSelf: "flex-start",
      marginTop: 8
    },
  
    tradeText: {
      fontSize: 14,
      fontWeight: "500"
    }
  })
  